import React, {Component} from 'react';
import classNames from 'classnames';
import store from 'store';

import {
    Button,
    Card, CardBody, CardGroup, CardImgOverlay, CardSubtitle, CardTitle,
    Col
} from 'reactstrap';

import PolyUtil from '../../util/PolyUtil';
import CardCoverImage from '../media/images/CardCoverImage';
import {Link} from 'react-router';

class WidePropertyCard extends Component {
    state = {
        mouseHover: false
    };

    setMouseHover = (value) => {
        this.setState({mouseHover: value});
    };

    render() {
        const {display_address, city, state, identifier, image, imageOnly, propertyUrl, isListed, noListingButton} = this.props;
        let url = image;

        if (url === null) {
            url = PolyUtil.buildStreetViewUrl(600, 440, display_address + "," + city + "," + state);
        }

        const cardClassname = classNames({
            'property-card': true,
            'animated': true,
            'fadeIn': true,
            'mb-4': true,
            'property-card-disabled': !isListed,
        });

        if (imageOnly) {
            return (
                <Col md={3} sm={6} xs={12}>
                    <Card className={cardClassname} inverse style={{padding: 0, border: 'none'}}
                          onMouseEnter={() => this.setMouseHover(true)}
                          onMouseLeave={() => this.setMouseHover(false)}>
                        <CardCoverImage
                            src={url}
                            gradStart="rgba(20,20,20, .5)"
                            gradEnd="rgba(50,50,50, .5)"
                        />
                        <CardImgOverlay className="d-flex">
                            <CardBody className="align-self-center">
                                {
                                    (this.state.mouseHover && !isListed) ? (
                                        <div className="text-center animated fadeIn">
                                            <h5 className="text-white">No Listing Available</h5>
                                            {
                                                noListingButton
                                            }
                                        </div>
                                    ) : this.state.mouseHover ? (
                                        <Button block
                                                className="text-center animated fadeIn property-card-button"
                                                style={{zIndex: 1000000}}
                                                tag={Link}
                                                to={propertyUrl}
                                                onClick={() => store.set('prev', 'dashboard')}
                                                outline>
                                            View Listing
                                        </Button>
                                    ) : (
                                        <div>
                                            <CardTitle className="text-center">{display_address} {identifier && (' (' + identifier + ')')}</CardTitle>
                                            <CardSubtitle
                                                className="text-center">{city + (state ? ', ' + state : '')}</CardSubtitle>
                                        </div>
                                    )
                                }
                            </CardBody>

                        </CardImgOverlay>
                    </Card>
                </Col>

            );
        }
        else {
            return (
                <Col sm="12" style={{overflow: 'visible'}}>
                    <CardGroup className="row property-card animated fadeIn mb-4">
                        <Card className="col-md-4 mb-0" inverse
                              style={{padding: 0, border: 'none'}}>
                            <Link className="full-link" to={propertyUrl}/>
                            <CardCoverImage
                                src={url}
                                gradStart="rgba(20,20,20, .5)"
                                gradEnd="rgba(50,50,50, .5)"
                            />
                            <CardImgOverlay className="d-flex">
                                <CardBody className="align-self-center">
                                    <CardTitle className="text-center">{display_address} {identifier && (' (' + identifier + ')')}</CardTitle>
                                    <CardSubtitle
                                        className="text-center">{city + (state ? ', ' + state : '')}</CardSubtitle>
                                </CardBody>
                            </CardImgOverlay>
                        </Card>
                        <Card className="col-md-8 btr-0-mobile" body inverse color="default">
                            {this.props.children}
                        </Card>
                    </CardGroup>
                </Col>
            );
        }
    }
}

export default WidePropertyCard;



// WEBPACK FOOTER //
// ./src/components/properties/WidePropertyCard.js